import { gsap } from 'gsap'

// Get all the CTA buttons in the slider
document.querySelectorAll('.sections_reasons-slider').forEach((section) => {
  const ctaButtons = section.querySelectorAll('.agenda_cta')

  // Function to open the corresponding modal using GSAP
  ctaButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const slideNumber = button.getAttribute('data-slide') // Get slide number from the button
      const modal = document.querySelector(
        `.agenda_popup-modal[data-slide="${slideNumber}"]`
      ) // Find the corresponding modal outside the slider

      if (modal) {
        modal.style.display = 'flex' // Make the modal visible

        // Animate the modal's background and content into view
        gsap.fromTo(
          modal,
          { opacity: 0, pointerEvents: 'none', backdropFilter: 'blur(0px)' },
          {
            opacity: 1,
            pointerEvents: 'auto',
            backdropFilter: 'blur(10px)',
            duration: 0.5,
            ease: 'power2.out',
          }
        )
        gsap.fromTo(
          modal.querySelector('.agenda_popup-content'),
          { scale: 0.8, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.5, ease: 'power2.out' }
        )
      }
    })
  })

  // Function to close the modal using GSAP
  const closeModal = (modal) => {
    gsap.to(modal.querySelector('.agenda_popup-content'), {
      scale: 0.8,
      opacity: 0,
      duration: 0.3,
      ease: 'power2.in',
      onComplete: () => {
        // Once animation is complete, set display to none
        modal.style.display = 'none'
      },
    })
    gsap.to(modal, {
      opacity: 0,
      duration: 0.3,
      pointerEvents: 'none',
      backdropFilter: 'blur(0px)', // Animate the blur back to 0 when closing
    })
  }

  // Get all modals (they are outside the slider)
  // eslint-disable-next-line
  const modals = document.querySelectorAll('.agenda_popup-modal')
  const closeButtons = document.querySelectorAll('.agenda_close-icon-wrapper')
  const backgrounds = document.querySelectorAll('.agenda_popup-background')

  // Add close functionality to close buttons and background click
  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest('.agenda_popup-modal') // Find the modal closest to the clicked close button
      closeModal(modal)
    })
  })

  backgrounds.forEach((background) => {
    background.addEventListener('click', () => {
      const modal = background.closest('.agenda_popup-modal') // Find the modal closest to the clicked background
      closeModal(modal)
    })
  })
})
